import styled from "styled-components";

export const AppContainer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template: 1fr 4fr / 100%;
`;
